var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { ref: "modal", staticClass: "modal fade" }, [
    _c(
      "div",
      {
        staticClass: "modal-dialog modal-xl modal-dialog-scrollable",
        attrs: { role: "document" }
      },
      [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-header" }, [
            _c("h5", { staticClass: "modal-title" }, [
              _vm._v(_vm._s(_vm.$t("kanban.approval.listModal.title")))
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "close",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.dismiss.apply(null, arguments)
                  }
                }
              },
              [_vm._v("×")]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "modal-body" },
            [
              _c("ApprovalListTable", {
                attrs: { state: _vm.state },
                on: {
                  openCard: function($event) {
                    return _vm.$emit("openCard", $event)
                  }
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "modal-footer" }, [
            _c(
              "button",
              { staticClass: "btn btn-secondary", on: { click: _vm.dismiss } },
              [_vm._v(_vm._s(_vm.$t("btnClose")))]
            )
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }